import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { TimeoutManager } from '@enauka/shared/util';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogType, getCSSClass } from '../DialogType';

@Component({
  selector: 'enauka-popup-dialog',
  templateUrl: './popup-dialog.component.html',
  styleUrls: ['./popup-dialog.component.css']
})
export class PopupDialogComponent implements OnInit, OnDestroy {
  @Input() type: DialogType;
  @Input() message: string;
  @Input() time: number;
  private timeoutManager = new TimeoutManager();

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.timeoutManager.timeout(() => {
      this.activeModal.close('cancel');
    }, this.time);
  }

  ngOnDestroy(): void {
    this.timeoutManager.clear();
  }

  getClass() {
    return getCSSClass(this.type);
  }

  close() {
    this.activeModal.close('cancel');
  }

}
